export default {
  "content": "<path d=\"M8 7H5v12h12v-3h2v4a1 1 0 01-1 1H4a1 1 0 01-1-1V6a1 1 0 011-1h4v2z\" fill=\"#7B61FF\"/><path d=\"M20 3a1 1 0 011 1v6.5h-2V6.414l-6.793 6.793-1.414-1.414L17.586 5H13.5V3H20z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};